// TODO: Migrate to QdsSize and QdsImportance
// https://jira.se.com/browse/PEXS-15578
export enum EQdsButtonSize {
  SMALL = 'small',
  LARGE = 'large',
  STANDARD = 'standard',
}

export enum EQdsButtonImportance {
  EMPHASIZED = 'emphasized',
  STANDARD = 'standard',
  SUBDUED = 'subdued',
}

export enum QdsChipType {
  CLOSABLE = 'closable',
  SELECTABLE = 'selectable',
}

export enum QdsSize {
  SMALL = 'small',
  LARGE = 'large',
  STANDARD = 'standard',
}

export enum QdsImportance {
  EMPHASIZED = 'emphasized',
  STANDARD = 'standard',
  SUBDUED = 'subdued',
}

export enum QdsSelectType {
  SELECT_MULTIPLE = 'select-multiple',
  SELECT_ONE = 'select-one',
}

export const enum EQdsIcons {
  ARROW_DOWN = 'arrow-down',
  ARROW_DOWN_TRAY = 'arrow-down-tray',
  ARROW_TOP_RIGHT_ON_SQUARE = 'arrow-top-right-on-square',
  ARROW_UP = 'arrow_up',
  ARROW_UP_DOWN_CIRCLE = 'arrow-up-down-circle',
  ARROWS_FACING_RIGHT_LEFT = 'arrows-facing-right-left',
  BELL = 'bell',
  BELL_WAVES = 'bell-waves',
  BOX_ARROW_CLOCKWISE = 'box-arrow-clockwise',
  CHAT_BUBBLES_SQUARE_ELLIPSIS = 'chat-bubbles-square-ellipsis',
  CHECK_WRITING_BOARD = 'check-writing-board',
  CHECK_CIRCLE = 'check-circle',
  CHEVRON_LEFT = 'chevron-left',
  DOTS_3_MENU_HORIZONTAL = 'dots-3-horizontal',
  FINGER_POINTING_UP = 'finger-pointing-up',
  LAPTOP_SIDE = 'laptop-side',
  PAGE_LINES = 'page-lines',
  PAGE_PDF = 'page-pdf',
  PAGE_XLS = 'page-xlsx',
  PAGE_XML = 'page-xml',
  PAGES_DOUBLE = 'pages-double',
  PENCIL = 'pencil',
  PERSON_WRITING_PAD = 'person-writing-pad',
  PERSONS_SMALL_BIG = 'persons-small-big',
  RECTANGLE_LOCATION_PIN = 'rectangle-location-pin',
  SCREEN_GRAPH = 'screen-graph',
  SHOPPING_CART = 'shopping-cart',
  SHOPPING_CART_ARROW = 'shopping-cart-arrow',
  SQUARE_BEHIND_ANOTHER = 'square-behind-another',
  SQUARES_SELECTED = 'squares-checked',
  STAR = 'star',
  STAR_FILLED = 'star-on',
  TRASH_CAN = 'trash-can',
}

export const enum QDS_ICON_LIBRARIES {
  DEFAULT = 'default',
  CORE = 'core',
  GENERAL = 'general',
}

export const enum QDS_COMPONENT_STATUS {
  ERROR = 'error',
  INFO = 'info',
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export const QDS_ICON_PROPS = {
  [EQdsIcons.STAR_FILLED]: {
    library: QDS_ICON_LIBRARIES.CORE,
  },
} as const;

export const LINK_TYPES = {
  CONTACT_SALES: 'CONTACT_SALES',
  CONTACT_SUPPORT: 'CONTACT_SUPPORT',
  COMPARE: 'COMPARE',
  REGISTER_TO_NEWSLETTER: 'REGISTER_TO_NEWSLETTER',
  REGISTER_PRODUCT: 'REGISTER_PRODUCT',
  ADD_TO_MY_PRODUCTS: 'ADD_TO_MY_PRODUCTS',
  CHECK_DISTRIBUTOR: 'CHECK_DISTRIBUTOR',
  BUY_ONLINE: 'BUY_ONLINE',
  FIND_RESELLER: 'FIND_RESELLER',
};

export const BUTTON_TYPES = {
  ADD_TO_CART: 'ADD_TO_MY_CART',
  ADD_TO_MYLIST: 'ADD_TO_MY_LIST',
  NOTIFY_ME: 'NOTIFY_ME',
  VIEW_DETAILS: 'VIEW_DETAILS',
  DOWNLOAD_SOFTWARE: 'DOWNLOAD_SOFTWARE',
  VIEW_ONLINE_SOFTWARE: 'VIEW_ONLINE_SOFTWARE',
  SEE_SOFTWARE: 'SEE_SOFTWARE',
  PRODUCT_SELECTOR: 'PRODUCT_SELECTOR',
} as const;

export const ACTION_BLOCK_TYPES = {
  PRODUCTS_FROM_A_TO_Z: 'PRODUCTS_FROM_A_TO_Z',
  PRODUCT_SELECTOR_LIST: 'PRODUCT_SELECTOR_LIST',
  MASTER_RANGE_PRODUCT: 'MASTER_RANGE_PRODUCT',
  DOWNLOAD_CENTER: 'DOWNLOAD_CENTER',
};

export const ICONS_BY_TYPE = {
  [LINK_TYPES.CONTACT_SALES]: EQdsIcons.CHECK_WRITING_BOARD,
  [LINK_TYPES.CONTACT_SUPPORT]: EQdsIcons.CHAT_BUBBLES_SQUARE_ELLIPSIS,
  [LINK_TYPES.REGISTER_TO_NEWSLETTER]: EQdsIcons.BELL_WAVES,
  [LINK_TYPES.REGISTER_PRODUCT]: EQdsIcons.PAGE_LINES,
  [LINK_TYPES.CHECK_DISTRIBUTOR]: EQdsIcons.CHECK_WRITING_BOARD,
  [LINK_TYPES.BUY_ONLINE]: EQdsIcons.SHOPPING_CART_ARROW,
  [LINK_TYPES.FIND_RESELLER]: EQdsIcons.RECTANGLE_LOCATION_PIN,
  // All-products
  [ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z]: 'action_filter',
  [ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST]: 'product_selector',
  [ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT]: 'box1',
  [ACTION_BLOCK_TYPES.DOWNLOAD_CENTER]: 'action_doc_new',
  // Buttons
  [BUTTON_TYPES.ADD_TO_CART]: EQdsIcons.SHOPPING_CART,
  [BUTTON_TYPES.ADD_TO_MYLIST]: EQdsIcons.STAR,
  [BUTTON_TYPES.DOWNLOAD_SOFTWARE]: EQdsIcons.ARROW_DOWN_TRAY,
  [BUTTON_TYPES.VIEW_ONLINE_SOFTWARE]: EQdsIcons.ARROW_TOP_RIGHT_ON_SQUARE,
  [BUTTON_TYPES.SEE_SOFTWARE]: EQdsIcons.SQUARE_BEHIND_ANOTHER,
  [BUTTON_TYPES.PRODUCT_SELECTOR]: EQdsIcons.SQUARES_SELECTED,
};

export const TARGET_BY_TYPE = {
  [LINK_TYPES.CONTACT_SALES]: '_self',
  [LINK_TYPES.CONTACT_SUPPORT]: '_blank',
  [LINK_TYPES.REGISTER_PRODUCT]: '_blank',
  [LINK_TYPES.CHECK_DISTRIBUTOR]: '_self',
  [BUTTON_TYPES.NOTIFY_ME]: '_blank',
  [BUTTON_TYPES.VIEW_DETAILS]: '_self',
};
